<ng-container *ngIf="globals && globals.company && !globals.company.setUpComplete">
    <ng-container *ngIf="(stepsRelevant.length > 0) && (stepsIncomplete.length !== 0)">
        <span class="step-message"
              [title]="stepsIncomplete.length + ' step' + (stepsIncomplete.length > 1 ? 's' : '') + ' remaining'">{{stepsIncomplete.length}}
            step{{(stepsIncomplete.length > 1) ? 's' : ''}} remaining</span>
    </ng-container>
</ng-container>